import { Link } from "react-router-dom";
import { Phone, MapPin, Clock, Facebook, Navigation } from "lucide-react";
import { RESTAURANT } from "../data/restaurant";
import OpenNowBadge from "../components/OpenNowBadge";

export default function Contact() {
  return (
    <div data-testid="contact-page" className="bg-[#FAF8F5]">
      {/* Hero */}
      <section className="max-w-7xl mx-auto px-6 md:px-12 pt-12 md:pt-20 pb-10">
        <div className="text-xs tracking-[0.25em] uppercase text-[#C9853E] font-bold mb-4">
          Visit · Order · Say Hi
        </div>
        <h1 className="font-display text-5xl md:text-7xl font-extrabold leading-[1.02] text-[#0E0E1A]">
          Find us in<br />
          <span className="font-accent italic font-medium text-[#C9853E]">Lethbridge.</span>
        </h1>
      </section>

      <section className="max-w-7xl mx-auto px-6 md:px-12 pb-20 md:pb-28">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8">
          {/* Map */}
          <div className="lg:col-span-7 rounded-3xl overflow-hidden border border-[#E7E5E4] aspect-[4/3] lg:aspect-auto lg:min-h-[520px] bg-white">
            <iframe
              data-testid="contact-map"
              title="Rivaaz location map"
              src={RESTAURANT.mapsEmbed}
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              className="w-full h-full border-0"
              allowFullScreen
            />
          </div>

          {/* Info */}
          <div className="lg:col-span-5 flex flex-col gap-5">
            <div className="bg-white border border-[#E7E5E4] rounded-3xl p-7">
              <div className="flex items-start gap-3 mb-1">
                <MapPin className="w-5 h-5 text-[#C9853E] mt-0.5 shrink-0" />
                <div>
                  <div className="text-[10px] tracking-[0.25em] uppercase text-[#C9853E] font-bold">Address</div>
                  <div className="font-display text-lg font-bold text-[#0E0E1A] mt-1">
                    {RESTAURANT.address}
                  </div>
                </div>
              </div>
              <a
                href={RESTAURANT.mapsLink}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="contact-directions-btn"
                className="inline-flex items-center gap-2 mt-5 text-sm font-bold text-[#0E0E1A] hover:text-[#C9853E] transition-colors"
              >
                <Navigation className="w-4 h-4" /> Get directions
              </a>
            </div>

            <Link
              to="/menu"
              data-testid="contact-order-online-btn"
              className="bg-[#C9853E] hover:bg-[#A6692D] text-white rounded-3xl p-7 transition-all hover:-translate-y-0.5 shadow-[0_10px_25px_-8px_rgba(201,133,62,0.5)] block"
            >
              <div className="flex items-center gap-3 mb-1">
                <Phone className="w-5 h-5" />
                <div className="text-[10px] tracking-[0.25em] uppercase font-bold">Order online for pickup</div>
              </div>
              <div className="font-display text-2xl font-extrabold mt-2">Browse the menu</div>
              <div className="text-white/80 text-sm mt-1">Pay online or at pickup · ready in ~25 min</div>
            </Link>

            <a
              href={`tel:${RESTAURANT.phoneRaw}`}
              data-testid="contact-call-btn"
              className="bg-white border border-[#E7E5E4] hover:border-[#0E0E1A] rounded-3xl p-7 transition-all block"
            >
              <div className="flex items-center gap-3 mb-1">
                <Phone className="w-5 h-5 text-[#C9853E]" />
                <div className="text-[10px] tracking-[0.25em] uppercase font-bold text-[#C9853E]">Call to order</div>
              </div>
              <div className="font-display text-3xl font-extrabold text-[#0E0E1A] mt-2">{RESTAURANT.phone}</div>
              <div className="text-[#57534E] text-sm mt-1">Most in-store orders ready in ~12 minutes</div>
            </a>

            <div className="bg-white border border-[#E7E5E4] rounded-3xl p-7">
              <div className="flex items-center justify-between mb-4 gap-3 flex-wrap">
                <div className="flex items-center gap-3">
                  <Clock className="w-5 h-5 text-[#C9853E]" />
                  <div className="text-[10px] tracking-[0.25em] uppercase text-[#C9853E] font-bold">Hours</div>
                </div>
                <OpenNowBadge variant="light" />
              </div>
              <ul className="divide-y divide-[#E7E5E4]" data-testid="contact-hours-list">
                {RESTAURANT.hours.map((h) => (
                  <li key={h.day} className="flex items-center justify-between py-2.5">
                    <span className="font-semibold text-[#0E0E1A]">{h.day}</span>
                    <span className="text-[#57534E] text-sm">{h.time}</span>
                  </li>
                ))}
              </ul>
            </div>

            <a
              href={RESTAURANT.facebook}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="contact-facebook-btn"
              className="bg-white border border-[#E7E5E4] rounded-3xl p-5 flex items-center gap-4 hover:border-[#0E0E1A] transition-colors"
            >
              <div className="w-11 h-11 rounded-full bg-[#0E0E1A] text-white flex items-center justify-center">
                <Facebook className="w-5 h-5" />
              </div>
              <div>
                <div className="font-display font-bold text-[#0E0E1A]">Follow on Facebook</div>
                <div className="text-sm text-[#57534E]">facebook.com/rivaazpizza</div>
              </div>
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}
